module.exports = __webpack_public_path__ + "static/assets/c19282f27937a0db7e8146672018fa8b.jpg";